import { useState } from "react";

const useFormData = <T>() => {
  const [formData, setFormData] = useState<T | undefined>(undefined);

  const onChangeFormData = (value: any, field: string) => {
    setFormData((oldValue) => {
      return { ...oldValue!, [field]: value };
    });
  };

  return {
    formData,
    setFormData,
    onChangeFormData,
  };
};

export default useFormData;
